const benefits = [
  {
    icon: 'ri-search-line',
    title: 'Schnellere Produktsuche',
    desc: 'Finde Produkte ohne stundenlange Suche in verschiedenen Shops. Das OOPBUY Spreadsheet bündelt alle relevanten Informationen an einem Ort.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20magnifying%20glass%20on%20warm%20cream%20desk%20with%20organized%20product%20cards%2C%20soft%20natural%20window%20light%2C%20modern%20European%20aesthetic%2C%20efficient%20search%20concept%2C%20warm%20neutral%20beige%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20sophisticated%20productivity%20scene&width=600&height=400&seq=oopbuy-benefit-suche&orientation=landscape',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Bessere Übersicht',
    desc: 'Vergleiche Kategorien und Produkte auf einen Blick. Die strukturierte Darstellung macht Unterschiede sofort sichtbar.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20organized%20grid%20layout%20with%20neatly%20arranged%20fashion%20item%20cards%20on%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20modern%20European%20minimalist%20aesthetic%2C%20visual%20comparison%20concept%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20clean%20structured%20composition&width=600&height=400&seq=oopbuy-benefit-uebersicht&orientation=landscape',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Einfacher Einstieg',
    desc: 'Ideal für Anfänger, die noch keine Erfahrung mit internationalen Bestellplattformen haben. Schritt-für-Schritt alles verständlich erklärt.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20welcoming%20beginner%20guide%20concept%20with%20open%20instruction%20book%20and%20simple%20icons%20on%20cream%20desk%2C%20soft%20natural%20lighting%2C%20modern%20European%20interior%20style%2C%20easy%20learning%20atmosphere%2C%20warm%20neutral%20beige%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20approachable%20friendly%20composition&width=600&height=400&seq=oopbuy-benefit-einstieg&orientation=landscape',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Mehr Kontrolle',
    desc: 'Produkte strukturiert analysieren und fundierte Kaufentscheidungen treffen. Behalte jederzeit den Überblick über deine Optionen.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20control%20panel%20concept%20with%20organized%20dashboard%20cards%20on%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20modern%20European%20aesthetic%2C%20data%20driven%20decision%20theme%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20sophisticated%20analytic%20composition&width=600&height=400&seq=oopbuy-benefit-kontrolle&orientation=landscape',
  },
];

export default function WhySection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            Warum nutzen deutsche Käufer ein <strong>OOPBUY Spreadsheet</strong>?
          </h2>
          <div className="w-12 h-0.5 bg-primary-400 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-200/50 transition-all duration-300 group flex flex-col"
            >
              <div className="aspect-[3/2] relative overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${item.icon} text-base`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}